import * as yup from "yup";
import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useMemo } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import SecondaryButton from "../SecondaryButton";
import { CompanyObject } from "../../types/Company"; // il tuo type
import InputLg from "../InputLg";
import useCompany from "../../context/CompanyContext";


const InputSchema = yup.object().shape({
  descrizione: yup.string().required("Descrizione obbligatoria").max(250, "La descrizione dev'essere inferiore a 250 caratteri"),
 sito_web_link: yup
  .string()
  .matches(
    /^(https?:\/\/)([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/,
    "Deve essere un URL valido e iniziare con http:// o https://"
  ),
  logo: yup
    .mixed()
    .test("fileSize", "Il file è troppo grande", (value: any) => {
      if (!value?.length) return true; // opzionale
      return value[0].size <= 2000000; // 2MB
    })
    .test("fileType", "Solo immagini sono permesse", (value: any) => {
      if (!value?.length) return true;
      return ["image/jpeg", "image/png", "image/webp"].includes(value[0].type);
    }),
});

interface Props {
  title: string;
  closeModal: () => void;
  onSubmit: (data: CompanyObject) => void;
}

const FormModal: React.FC<Props> = ({ title, closeModal, onSubmit }) => {
  const companyContext = useCompany();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<CompanyObject>({
      defaultValues: {
      ...companyContext.data,
    },
    resolver: yupResolver(InputSchema),
  });
console.log('error',errors);

  return (
    <Transition appear show as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95">
              <Dialog.Panel className="w-full max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title as="h3" className="font-primarybold text-lg font-medium leading-6 text-primary">
                  {title}
                </Dialog.Title>

                <form className="mt-4 flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
                  {/* Campo Descrizione */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Descrizione</label>
                    <textarea
                      {...register('descrizione')}
                      className="px-4 py-2 mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary sm:text-sm"
                      rows={3}
                    />
                    {errors.descrizione && <p className="mt-1 text-xs text-red">{errors.descrizione.message}</p>}
                  </div>

                  {/* Campo Sito Web */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700">Sito Web</label>
                    <input
                      type="text"
                      {...register('sito_web_link')}
                      className="px-4 py-2 text-sm text-left text-textgrey !w-full"
                    />
                    {errors.sito_web_link && (
                      <p className="mt-1 text-xs text-red">{errors.sito_web_link.message as string}</p>
                    )}
                  </div>                

                  <div className="mb-4">
                    {/* Mostra l'anteprima solo se esiste */}
                    {(watch('logo') as any)?.url && (
                      <>
                        <label className="block text-sm font-medium text-gray-700">Logo attuale</label>
                        <div className="mt-2 flex items-center gap-4">
                          <img
                            src={`${process.env.REACT_APP_API_URL}${(watch('logo') as any).url}`}
                            alt={(watch('logo') as any).alternativeText || (watch('logo') as any).name}
                            className="h-16 w-auto rounded-md shadow"
                          />
                          <span className="text-sm text-gray-500">{(watch('logo') as any).name}</span>
                        </div>
                      </>
                    )}

                    <label className="block text-sm font-medium text-gray-700 mt-4">Carica nuovo logo</label>
                    <input
                      type="file"
                      accept="image/*"
                      {...register('logo')}
                      className="mt-1 block w-full text-sm text-gray-500"
                    />
                     {errors.logo && (
                      <p className="mt-1 text-xs text-red">{errors.logo.message as string}</p>
                    )}
                  </div>

                  {/* Bottoni */}
                  <div className="mt-6 flex justify-end gap-2">
                    <SecondaryButton type="button" className="w-auto" text="Chiudi" onClick={closeModal} />
                    <SecondaryButton type="submit" className="w-auto !bg-primary text-white" text="Salva" />
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default FormModal;
